import { makeStyles, tokens } from "@fluentui/react-components";
import { FormEventHandler } from "react";

export const useDropboxTextAreaStyles = makeStyles({
  inputContainer: {
    minWidth: "66%",
    "@media screen and (max-width: 400px)": { minWidth: "80%" },
  },
  input: {
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    boxSizing: "content-box",
    minHeight: "80px",
    width: "100%",
  },
});

export const onInputHandleResize: FormEventHandler<HTMLTextAreaElement> = (ev) => {
  const { style } = ev.currentTarget;
  style.height = style.minHeight = "auto";
  style.minHeight = `${Math.min(ev.currentTarget.scrollHeight + 4, parseInt(style.maxHeight))}px`;
  style.height = `${ev.currentTarget.scrollHeight + 4}px`;
};
